import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import App from './App.vue'
import router from './router'
import './styles/main.css'
import Vueform from '@vueform/vueform'
import vueformConfig from './vueform.config'
import { vPermission } from './directives/vPermission'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.directive('permission', vPermission)

import { useUiStore } from './stores/ui'
const uiStore = useUiStore()
uiStore.initTheme()

import { useAuthStore } from './stores/auth'
const authStore = useAuthStore()

authStore.initialize().then(() => {
  app.use(router)
  app.use(VueQueryPlugin)
  app.use(Vueform, vueformConfig)
  app.mount('#app')
})
